import { ArticleTextileType } from '@project-management-system/shared-models';
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn } from 'typeorm';
import { ApparelArticleMasterVersions } from './apparel-article-masters-versions.entity';

@Entity('_versions_fabric_trims_master')
export class FabricTrimsMasterVersions {
    @PrimaryGeneratedColumn()
    id: number;

    @Column({ name: 'product', type: 'varchar', length: 255 })
    product: string;

    @Column({ name: 'material_name', type: 'varchar', length: 255 })
    materialName: string;

    @Column({ name: 'supplier_article_number', type: 'varchar', length: 255 })
    supplierArticleNumber: string;

    @Column({ name: 'gauge_ends', type: 'varchar', length: 255 })
    gaugeEnds: string;

    @Column({ name: 'stitch', type: 'varchar', length: 255 })
    stitch: string;

    @Column({ name: 'common_size', type: 'varchar', length: 255 })
    commonSize: string;

    @Column({ name: 'common_qty', type: 'int' })
    commonQty: number;

    @Column({ name: 'usage', type: 'varchar', length: 255 })
    usage: string;

    @Column({ name: 'image', type: 'varchar', length: 255 })
    image: string;

    @Column({ name: 'primary_rd', type: 'varchar', length: 255 })
    primaryRD: string;

    @Column({ name: 'quality_details', type: 'text', nullable: true })
    qualityDetails: string;

    @Column({ name: 'supplier_allocate', type: 'varchar', length: 255 })
    supplierAllocate: string;

    @Column({ name: 'uom', type: 'varchar', length: 50 })
    uom: string;

    @Column({ name: 'only_for_product_colors', type: 'varchar', length: 255 })
    onlyForProductColors: string;

    @Column({ name: 'ivory_frost', type: 'varchar', length: 255, nullable: true })
    ivoryFrost: string;

    @Column({ name: 'navy_uniform_heart', type: 'varchar', length: 255, nullable: true })
    navyUniformHeart: string;

    @Column({ name: 'bedrock_heart', type: 'varchar', length: 255, nullable: true })
    bedrockHeart: string;

    @Column({ name: 'ivory_frost_heart', type: 'varchar', length: 255, nullable: true })
    ivoryFrostHeart: string;

    @Column({ name: 'primitive', type: 'varchar', length: 255, nullable: true })
    primitive: string;

    @ManyToOne(() => ApparelArticleMasterVersions, (am) => am.versionsFabricId)
    @JoinColumn({ name: 'versions_apparel_article_id' })
    versionApparelArticleId: ApparelArticleMasterVersions;

    @Column({
        name: 'type', type: 'enum', enum: ArticleTextileType, enumName: 'article_textile_type',
    })
    type: ArticleTextileType;

    @CreateDateColumn({
        name: "created_at",
    })
    createdAt: string;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "created_user",
    })
    createdUser: string | null;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user",
    })
    updatedUser: string | null;

    @CreateDateColumn({
        name: "updated_at",
    })
    updatedAt: string;
}
